<div class="flip-card" [class.flipped]="insightsFlipped">
  <div class="insights-flip-card-inner">
    <!-- Front Side -->
    <div class="flip-card-front">
      <div id="first-block" class="card-block dark page-container">
        <div class="card-wrap d-flex justify-content-between">
          <app-navbar (tabSelected)="onTabSelected($event)"></app-navbar>
          <div class="card-content">
            <div class="gi-row" *ngIf="selectedTab !== 'live'">
              <div class="gi-text">
                <h1 class="title fw-300 text-color custom-mb">
                  {{ title }} <b>Insights</b>
                  <mat-icon class="insights-flip-icon" (click)="flipInsights()">list_alt</mat-icon>
                </h1>
                <div class="row align-items-center">
                  <div class="d-flex align-items-center gap-10x col-lg-2 col-xxl-6 date-picker-container">
                    <app-date-picker (dateRangeSelected)="handleDateRangeSelected($event)"
                      [resetDatePicker]="resetDatePicker">
                    </app-date-picker>
                    <app-range-picker [ranges]="rangeData" [selectedRange]="selectedRange" [dateRange]="dateRange"
                      (rangeClick)="handleRangeClick($event)" (rangeReset)="onRangeReset()">
                    </app-range-picker>
                  </div>
                  <app-sites-insights class="col-lg-9 col-xxl-6 align-content-center pl-0"
                    *ngIf="selectedTab === 'overview'" [data]="siteInsightData"></app-sites-insights>
                </div>
              </div>
            </div>
            <div *ngIf="selectedTab === 'overview'">
              <div class="row first-widget-container" [style.minHeight]="overviewMinHeight+'vh'">
                <div class="col-lg-12 col-xxl-6  custom-px ">
                  <app-top-sites></app-top-sites>
                </div>
                <div class="col-lg-12 col-xxl-6  pl-0 pr-3 right-container">
                  <div class="right-inner-container">
                    <app-total-alarms class="d-flex flex-column flex-grow-1"></app-total-alarms>
                  </div>
                  <div class="right-inner-container">
                    <app-alarm-operator-ratio class="d-flex flex-column flex-grow-1"></app-alarm-operator-ratio>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="selectedTab === 'alarm'">
              <div class="row first-widget-container" [style.minHeight]="alarmMinHeight+'vh'">
                <div class="col-xxl-6  custom-px">
                  <app-false-rate></app-false-rate>
                </div>
                <div class="col-xxl-6  pl-0 pr-3">
                  <app-repeated-alarms></app-repeated-alarms>
                </div>
              </div>
            </div>
            <div *ngIf="selectedTab === 'operator'">
              <div id="operator-activity-tab" class="carousel slide" data-ride="carousel" data-interval="5000">
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <div class="col-xxl-12  px-4 d-flex flex-column" [style.minHeight]="operatorMinHeight+'vh'">
                      <app-operator-activity class="d-flex flex-column flex-grow-1"
                        id="operator2"></app-operator-activity>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <div class="col-xxl-12  px-4 d-flex flex-column" [style.minHeight]="operatorMinHeight+'vh'">
                      <app-operator-ranking class="d-flex flex-column flex-grow-1"
                        id="operator2"></app-operator-ranking>
                    </div>
                  </div>
                </div>
                <a class="carousel-control-prev" href="#operator-activity-tab" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#operator-activity-tab" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="sr-only">Next</span>
                </a>
              </div>
            </div>
            <div *ngIf="selectedTab === 'detailed'" class="card-wrap d-flex justify-content-between flex-column">
              <div class="row">
                <div class="col-lg-12 d-flex flex-column custom-mb" [style.minHeight]="'2vh'">
                  <app-alarm-severity class="d-flex flex-column flex-grow-1" [data]="severityData"></app-alarm-severity>
                </div>
                <div class="col-lg-12  d-flex flex-column" [style.minHeight]="timeOfTheDayMinHeight+ 'vh'">
                  <app-alarm-time-of-the-day class="d-flex flex-column flex-grow-1"></app-alarm-time-of-the-day>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Back Side -->
    <div class="send-alarm-flip-card-back">
      <app-workflow [alarm]="selectedAlarm"></app-workflow>
      <mat-icon class="insights-flip-icon" (click)="flipInsights()">insert_chart</mat-icon>
    </div>
  </div>
</div>